import React, { useRef, useState, useContext, useEffect } from "react";
import csvtojson from "csvtojson"; 
import { Button, Typography, Stack } from "@mui/material";
   


export default function ImportStudentFromCSV({ setCSVData, open , setLoadingData}) {
  // ===================== Change Language ==========================
  // const { language, setAlert } = useContext(AuthContext);
  // const { t } = translateLauguage(language);

  // const [csvData, setCSVData] = useState([]);

  // console.log("csvData", csvData);

  const fileInputRef = useRef(null);
  const [fileName, setFileName] = useState("");

  const handleFileUpload = async (event) => {
    setLoadingData(true);

    const file = event.target.files?.[0];
    if (!file) return;

    setFileName(file.name);

    const reader = new FileReader();
    reader.onload = async (e) => {
      const csvText = e.target?.result;
      const json = await csvtojson().fromString(csvText);
      setCSVData(json);
    };
    reader.readAsText(file);

    setTimeout(() => {
      setLoadingData(false)
    }, 2000);
    
  };

  useEffect(() => {
    setFileName("")
  },[open])

  return (
    <div>
      {/* Hidden File Input */}
      <input
        type="file"
        accept=".csv"
        ref={fileInputRef}
        onChange={handleFileUpload}
        style={{ display: "none" }}
      />

      <Button
        className="import-csv-container"
        onClick={() => fileInputRef.current?.click()}
        // startIcon={<FaFileCsv className="icon-add" />}
      >
        <Stack direction="column" spacing={1} alignItems="center"> 
          <Typography
            // className={language === "kh" ? "import-txt-kh" : "import-txt"}
          >
            {fileName ? fileName : "select_file"}
          </Typography>
        </Stack>
      </Button>
    </div>
  );
}
